import React, { useCallback, useState, useRef } from "react";
import { PatternFormat } from "react-number-format";
import {
  Select,
  MenuItem,
  FormControl,
  SelectChangeEvent,
  CircularProgress,
  Backdrop,
  Button,
  createTheme,
  ThemeProvider,
  Box,
  TextField,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import CommonHeader from "../components/CommonHeader";
import styles from "./ImageGalleryComponentPc.module.css";
import axios from "axios";

interface Image {
  location: string;
  name: string;
}

type Option = {
  location: string;
  locationNumber: string;
  maxEquipment: number;
  EquipmentList: string[];
};

type TimeOption = {
  timeDirectory: string;
  time: string;
};
const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: "#6495ed",
          color: "#fff",
          fontSize: "1.0rem",
          padding: "5px 20px",
          "&:hover": {
            backgroundColor: "#4169e1",
          },
        },
      },
    },
  },
});
const backBtnTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: "#c0c0c0",
          color: "#fff",
          fontSize: "1.0rem",
          padding: "5px 20px",
          "&:hover": {
            backgroundColor: "#a9a9a9",
          },
        },
      },
    },
  },
});

const ImageGalleryComponentSp = () => {
  const [images, setImages] = useState<Image[]>([]);
  const [currentIndexNumber, setCurrentIndexNumber] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedImage, setSelectedImage] = useState<string>("");
  const [selectedImageName, setSelectedImageName] = useState<string>("");
  const [pageloaded, setPageloaded] = useState<boolean>(false);
  const [ageSl, setAgeSl] = useState<string>("");
  const [priceSl, setPriceSl] = useState<string>("");
  const [selectedPlaceSlbox, setSelectedPlaceSlbox] = useState("");
  const [selectedChairNumberSlbox, setSelectedChairNumberSlbox] = useState("");
  const [selectedTimeSlBox, setSelectedTimeSlBox] = useState("");
  const [liftSettingList, setLiftSettingList] = useState<Option[]>([]);
  const [searceTimeList, setSearchTimeList] = useState<TimeOption[]>([]);
  const location = useLocation();
  const navigate = useNavigate();
  const placeNumberSelectRef = useRef("");
  const chairNumberSelectRef = useRef("");
  const timeSelectRef = useRef("");
  const commonFontSize: number = 14;

  const handleChangePlaceSlbox = (event: SelectChangeEvent<string>) => {
    placeNumberSelectRef.current = event.target.value;
    setSelectedPlaceSlbox(event.target.value);
    fetchImages();
  };
  const handleChangeLiftChairSlbox = (event: SelectChangeEvent<string>) => {
    const trimmedValue = event.target.value.replace(/\s+/g, "");
    chairNumberSelectRef.current = trimmedValue;
    setSelectedChairNumberSlbox(trimmedValue);
  };
  const handleChangeTimeSlBox = (event: SelectChangeEvent<string>) => {
    timeSelectRef.current = event.target.value;
    setSelectedTimeSlBox(event.target.value);
    fetchImages();
  };
  const handleLoadingClose = () => {
    setLoading(false);
  };

  const getLocalStorageKey = () => {
    const key = localStorage.getItem("today-key");
    if (key) {
      return key;
    }
  };
  // プルダウンで選択中の設定値を取得
  const getLocationConfigCurrentValue = useCallback(() => {
    let selectedPlaceSlboxNumber = liftSettingList.find(
      (option) => option.location === placeNumberSelectRef.current,
    )?.locationNumber;
    if (selectedPlaceSlboxNumber === undefined) {
      selectedPlaceSlboxNumber = "1";
    }
    return selectedPlaceSlboxNumber;
  }, [liftSettingList]);
  // プルダウンで選択中の設定値を取得
  const getTimeConfigCurrentValue = useCallback(() => {
    let selectedTimeDirectory = searceTimeList.find(
      (option) => option.time === timeSelectRef.current,
    )?.timeDirectory;
    if (selectedTimeDirectory === undefined) {
      selectedTimeDirectory = "1";
    }
    return selectedTimeDirectory;
  }, [searceTimeList]);

  const fetchImages = useCallback(() => {
    if (
      placeNumberSelectRef.current === "" ||
      chairNumberSelectRef.current === "" ||
      timeSelectRef.current === ""
    ) {
      return;
    } else {
      const selectedPlaceSlboxNumber = getLocationConfigCurrentValue();
      const selectedTimeDirectory = getTimeConfigCurrentValue();
      setLoading(true);
      axios
        .post(
          "https://qjwbnw6til.execute-api.ap-northeast-1.amazonaws.com/poc",
          {
            directory: `iizuna/line${selectedPlaceSlboxNumber}/chair${chairNumberSelectRef.current}/timezone${selectedTimeDirectory}/thumbnails`,
            currentIndex: currentIndexNumber,
          },
        )
        .then((response) => {
          if (response.data.length > 0) {
            setImages(response.data);
          }
          setCurrentIndexNumber(currentIndexNumber + 50);
        })
        .catch((error) => {
          console.error("Error fetching images:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [
    currentIndexNumber,
    getLocationConfigCurrentValue,
    getTimeConfigCurrentValue,
  ]);

  const openModal = (image: Image) => {
    setSelectedImage(image.location);
    setSelectedImageName(image.name.replace("thumbnail/", ""));
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const countUpdl = () => {
    const url =
      "https://jt5dpke75h.execute-api.ap-northeast-1.amazonaws.com/poc";
    axios.post(url).then((response) => {
      console.log(
        "uplolad countup data, statusCode:",
        response.data.statusCode,
      );
    });
  };

  const uploadSurvey = () => {
    const url =
      "https://rxh8m6izkg.execute-api.ap-northeast-1.amazonaws.com/poc";
    axios
      .post(url, {
        survey_data: [ageSl, priceSl],
      })
      .then((response) => {
        console.log(
          "upload survey data, statusCode:",
          response.data.statusCode,
        );
      })
      .catch((error) => {
        console.error("Error upload survey data:", error);
      });
  };

  const downloadImage = () => {
    const selectedPlaceSlboxNumber = getLocationConfigCurrentValue();
    const selectedTimeDirectory = getTimeConfigCurrentValue();
    const basePrefixString = `iizuna/line${selectedPlaceSlboxNumber}/chair${chairNumberSelectRef.current}/timezone${selectedTimeDirectory}`;
    const imageNameWithoutPrefix = selectedImageName.replace(
      basePrefixString + "/thumbnails",
      "",
    );
    const url =
      "https://3s314s41z9.execute-api.ap-northeast-1.amazonaws.com/poc/poc-lift-iizuna-bucket/" +
      basePrefixString +
      "/contents" +
      imageNameWithoutPrefix;
    axios
      .get(url, {
        responseType: "blob",
      })
      .then((response) => {
        const blob = new Blob([
          response.data,
          {
            type: response.data.type,
          },
        ]);
        return blob;
      })
      .then((response) => {
        const url = URL.createObjectURL(response);
        const link = document.createElement("a");
        link.href = url;
        link.download = "downloaded-image.jpg";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        countUpdl();
        uploadSurvey();
      })
      .catch((error) => {
        console.error("Error download image:", error);
      });
  };

  // 初回レンダリング時に画像を取得。アンケート回答済みでなければアンケート画面に戻る
  React.useEffect(() => {
    const checkTodayKey = () => {
      const today = getLocalStorageKey();
      const url =
        "https://8slqmvh323.execute-api.ap-northeast-1.amazonaws.com/poc";
      axios
        .post(url, { verify_string: today })
        .then((response) => {
          if (response.data) {
            if (JSON.parse(response.data.body).authenticated) {
              const liftConfigList: Option[] = JSON.parse(
                response.data.body,
              ).equipmentLocations;
              const timeList: TimeOption[] = JSON.parse(
                response.data.body,
              ).timeList;
              setLiftSettingList(liftConfigList);
              setSearchTimeList(timeList);
              return;
            } else {
              navigate("/nottoday");
            }
            return;
          } else {
            navigate("/");
          }
        })
        .catch((error) => {
          console.error("Error checking today key:", error);
        });
    };
    if (pageloaded) {
      return;
    }
    if (location.state && location.state.answers.isAnswerd !== null) {
      if (!location.state.answers.isAnswerd) {
        navigate("/");
        return;
      } else if (location.state.answers.isAnswerd) {
        setAgeSl(location.state.answers.ageSl);
        setPriceSl(location.state.answers.priceSl);
      }
    } else {
      navigate("/");
      return;
    }
    checkTodayKey();
    const handleBack = () => {
      localStorage.setItem("ageSl", location.state.answers.ageSl);
      localStorage.setItem("priceSl", location.state.answers.priceSl);
      navigate("/questskiSp", { state: { answers: location.state.answers } });
    };

    window.onpopstate = () => {
      handleBack();
    };
    setPageloaded(true);
  }, [pageloaded, fetchImages, location.state, navigate]);

  return (
    <>
      <CommonHeader />
      <main className="p-8">
        <div>
          <div className={styles.searchComponentParent}>
            <FormControl
              sx={{
                m: 1,
                minWidth: 240,
                maxWidth: 240,
                marginLeft: 2,
                marginTop: 2,
                justifyContent: "center",
                display: "inline-flex",
              }}
            >
              <Select
                labelId="select-label-lift-place"
                id="select-lift-place"
                value={selectedPlaceSlbox}
                onChange={handleChangePlaceSlbox}
                displayEmpty
                sx={{
                  fontSize: commonFontSize,
                  color: selectedPlaceSlbox ? "#111111" : "#CCCCCC",
                }}
              >
                <MenuItem value="" disabled sx={{ fontSize: commonFontSize }}>
                  リフト種類
                </MenuItem>
                {liftSettingList.map((option, index) => (
                  <MenuItem
                    key={`${option.location}-${index}`}
                    value={option.location}
                    sx={{ fontSize: commonFontSize }}
                  >
                    {option.location}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Box
              sx={{
                m: 1,
                minWidth: 80,
                maxWidth: 80,
                marginRight: 2,
              }}
            >
              <PatternFormat
                format="####"
                valueIsNumericString={true}
                customInput={TextField}
                size="small"
                label="番号"
                variant="outlined"
                helperText=""
                InputLabelProps={{
                  style: {
                    fontSize: "10px",
                  },
                }}
                inputProps={{ inputMode: "numeric" }}
                sx={{
                  marginTop: 1,
                }}
                value={selectedChairNumberSlbox}
                onChange={handleChangeLiftChairSlbox}
              />
            </Box>
            <FormControl
              sx={{
                m: 1,
                width: "60%",
                maxWidth: 255,
                minWidth: 80,
                marginRight: 2,
                marginTop: 2,
                marginLeft: 5,
                justifyContent: "center",
              }}
            >
              <Select
                labelId="select-label-time"
                id="select-time"
                value={selectedTimeSlBox}
                onChange={handleChangeTimeSlBox}
                displayEmpty
                sx={{
                  fontSize: commonFontSize,
                  color: selectedTimeSlBox ? "#111111" : "#CCCCCC",
                }}
              >
                <MenuItem value="" disabled sx={{ fontSize: commonFontSize }}>
                  リフト乗車時間を選ぶ
                </MenuItem>
                {searceTimeList.map((option, index) => (
                  <MenuItem
                    key={`${option.time}-${index}`}
                    value={option.time}
                    sx={{ fontSize: commonFontSize }}
                  >
                    {option.time}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>

        <div className={styles.imageGallery}>
          {images.map((image, index) => (
            <div key={index} className={styles.imageItem}>
              <img
                src={image.location}
                onClick={() => openModal(image)}
                className={styles.galleryImage}
                alt=""
              />
            </div>
          ))}
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
            onClick={handleLoadingClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </div>
      </main>
      {showModal && (
        <div className={`${styles.modal} ${showModal ? styles.modalShow : ""}`}>
          <div className={styles.modalContent}>
            <img src={selectedImage} className={styles.modalImage} alt="" />
            <div className={styles.btnArea}>
              <ThemeProvider theme={theme}>
                <Button onClick={downloadImage}>ダウンロード</Button>
              </ThemeProvider>
              <ThemeProvider theme={backBtnTheme}>
                <Button onClick={closeModal}>もどる</Button>
              </ThemeProvider>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ImageGalleryComponentSp;
